import { GenericVehicleDetails } from '@finn/ua-vehicle';

import { COMPACT_SUV_FAKE_PRODUCT } from './compactSuv';
import { ELECTRIC_SUV_FAKE_PRODUCT } from './electricSuv';
import { SMALL_FAKE_PRODUCT } from './small';

export const FAKE_PRODUCTS = [
  { product: SMALL_FAKE_PRODUCT, position: 1 },
  { product: COMPACT_SUV_FAKE_PRODUCT, position: 3 },
  { product: ELECTRIC_SUV_FAKE_PRODUCT, position: 6 },
] as { product: GenericVehicleDetails; position: number }[];
